import { getHomePageUrl, goToUrl } from '../../utils/aem-utils';
import { isInjectedHPInView } from '../../utils/injected-hp-utils';
import { landToElement } from '../../utils/land-to-element';
import { getLoginUrl } from '../../utils/build-urls';
import { isMobile } from '../../utils/device-utils';
import { setStatusOnLocalStorage, BANNER_BOTTOM_STATUS } from '../../utils/local-storage';
import { RESPONSIVE_OFFSETS } from '../../utils/constants';

const DEFAULT_IS_FROM_BANNER_BOTTOM = false; // Default behaviour: click comes from slimBannerHP

/**
 * Land on the widget depending on several circumstances
 * @param {Boolean} isUserLogged
 * @param {String} widgetId
 * @param {String} tabId
 * @param {Boolean} isFromBannerBottom
 * @returns {Function}
 */
export const getHandleSlimBannerClick =
  ({ isUserLogged, widgetId, widgetTab, isFromBannerBottom = DEFAULT_IS_FROM_BANNER_BOTTOM }) =>
  (event) => {
    const homePageUrl = getHomePageUrl();
    const loginUrl = getLoginUrl(homePageUrl);
    const cannotLandInCurrentPage = (isMobile() && isInjectedHPInView()) || isFromBannerBottom;

    if (isFromBannerBottom) {
      setStatusOnLocalStorage({
        key: BANNER_BOTTOM_STATUS.OBJECT_KEY,
        name: BANNER_BOTTOM_STATUS.OK.NAME,
        expirationDays: BANNER_BOTTOM_STATUS.OK.EXPIRATION_DAYS,
      });
    }

    // Land on the widget in Home Page
    if (isUserLogged && cannotLandInCurrentPage) {
      event.preventDefault();
      landToElement.set({ elementId: widgetId, tabId: widgetTab });
      goToUrl(homePageUrl);
      return;
    }

    // Land on the widget on the current page
    if (isUserLogged) {
      event.preventDefault();
      const responsiveOffset = RESPONSIVE_OFFSETS.default;
      landToElement.land({ elementId: widgetId, tabId: widgetTab, responsiveOffset });
    }

    // Log-in then land on the widget in Home Page
    if (!isUserLogged) {
      event.preventDefault();
      landToElement.set({ elementId: widgetId, tabId: widgetTab });
      goToUrl(loginUrl);
    }
  };
